/* eslint-disable */
import axios from 'ggApp/utils/requests';

const createUser = userData => axios.post('/users', { user: userData }).then(res => (res.data || {}).user);

// eslint-disable-next-line import/prefer-default-export
export { createUser };
